import React from 'react'
import NumberInput, { NumberInputProps } from '../NumberInput/NumberInput'

export type AIRPNumberInputProps = NumberInputProps & {
  formatType?: 'currency' | 'integer' | 'decimal'
}

const inferFormatType = (props: NumberInputProps): 'currency' | 'integer' | 'decimal' => {
  if (props.symbol === '$') {
    return 'currency'
  }

  if (props.decimals === false || props.decimalPlaces === 0) {
    return 'integer'
  }

  if (props.decimals === true || (props.decimalPlaces !== undefined && props.decimalPlaces > 0)) {
    return 'decimal'
  }

  return 'integer'
}

function AIRPNumberInput(props: AIRPNumberInputProps) {
  const { formatType, ...rest } = props
  const resolvedFormatType = formatType ?? inferFormatType(rest)
  const formatProps = resolvedFormatType === 'currency'
    ? { decimalPlaces: 2 }
    : resolvedFormatType === 'integer'
      ? { decimalPlaces: 0, decimals: false }
      : rest.symbol === '%'
        ? { decimals: true, decimalPlaces: 2 }
        : { decimals: true }

  return (
    <NumberInput 
        negatives
        commas
        {...rest}
        {...formatProps}
        />
  )
}

export default AIRPNumberInput
